const productData = [
  {
    id: 1,
    name: "Eclipse Gem Minaudière",
    category: "Objects",
    price: "3600.00",
    reviews: "342",
    rating: "4.6",
    image: "/img/shiskerstone/product-01.svg#view-1",
    images: ["/img/shiskerstone/product-01.svg#view-1", "/img/shiskerstone/product-01.svg#view-2", "/img/shiskerstone/product-01.svg#view-3", "/img/shiskerstone/product-01.svg#view-4"],
    size: ["One size"],
    colors: ["Gold", "Onyx"],
    material: "18k Gold with precious stones",
    description: [
      "The Eclipse Gem Minaudière pairs a compact sculptural silhouette with polished metal and contrasting stone inlay.",
      "Its asymmetric surface is finished by hand to create changing highlights while keeping the form clean and contemporary.",
      "A discreet push-button clasp opens to a softly lined interior sized for small evening essentials.",
      "The minaudiere's compact form belies its dramatic presence, making it the perfect companion for evening occasions and special moments.",
      "Each piece is individually numbered and comes with a certificate of authenticity, ensuring its value as a collectible work of art.",
    ],
    Features: [
      "Hand-crafted in 18k gold with high-polish finish",
      "Original asymmetric onyx and gemstone inlay",
      "Unique push-button clasp mechanism for secure closure",
      "Velvet-lined interior protects precious contents",
      "Comes with custom-designed presentation box",
      "Limited edition with individual numbering",
      "Dimensions: 8cm x 5cm x 2.5cm",
    ],
  },
  {
    id: 2,
    name: "Lapis Vine Holder",
    category: "Objects",
    price: "2600.00",
    reviews: "289",
    rating: "4.7",
    image: "/img/shiskerstone/product-02.svg#view-1",
    images: ["/img/shiskerstone/product-02.svg#view-1", "/img/shiskerstone/product-02.svg#view-2", "/img/shiskerstone/product-02.svg#view-3", "/img/shiskerstone/product-02.svg#view-4"],
    size: ["One size"],
    colors: ["Lapis", "Gold"],
    material: "18k Gold with Lapis Lazuli",
    description: [
      "The Lapis Vine Holder combines a slender polished form with a deep-blue natural stone accent and an original openwork vine detail.",
      "Each piece features natural lapis lazuli stones hand-selected for their deep celestial blue color and distinctive golden flecks of pyrite.",
      "The thorn motif climbs elegantly along the shaft, cast in 18k gold using the lost-wax technique to capture every delicate detail of the natural form.",
      "This sculptural accessory transcends its original function, becoming a wearable work of art that commands attention and conversation.",
      "The weighted construction provides comfortable handling, while the elongated form adds drama to any gesture.",
    ],
    Features: [
      "18k gold casting with brushed and polished finishes",
      "Natural lapis lazuli accent stone",
      "Organic thorn pattern climbing the shaft",
      "Lost-wax casting technique for intricate detail",
      "Weighted brass core for comfortable handling",
      "Suitable for standard cigarettes or as a decorative object",
      "Presentation box included",
    ],
  },
  {
    id: 3,
    name: "Suncrest Brooch",
    category: "Jewelry",
    price: "1450.00",
    reviews: "214",
    rating: "4.5",
    image: "/img/shiskerstone/product-03.svg#view-1",
    images: ["/img/shiskerstone/product-03.svg#view-1", "/img/shiskerstone/product-03.svg#view-2", "/img/shiskerstone/product-03.svg#view-3"],
    size: ["One size"],
    colors: ["18k Gold", "Silver"],
    material: "18k Gold or Sterling Silver",
    description: [
      "The Suncrest Brooch turns an irregular ring of hand-shaped rays into a bright, contemporary focal point.",
      "Rendered in polished 18k gold, its abstract central dome and varied rays create depth without relying on figurative motifs.",
      "The solar disc motif radiates from the center, catching light from every angle and creating a subtle shimmer effect throughout the day.",
      "This brooch works beautifully as a focal point on lapels, scarves, or as a decorative element on bags and hats.",
      "The secure pin mechanism ensures it stays in place while remaining easy to attach and remove as desired.",
    ],
    Features: [
      "Available in 18k yellow gold or sterling silver",
      "Abstract domed center with hand-shaped rays",
      "High-polish finish on central elements",
      "Secure spring pin mechanism",
      "Approximate dimensions: 4cm x 5cm",
      "Lightweight construction for comfortable wear",
      "Suitable for jackets, scarves, bags, and hats",
    ],
  },
  {
    id: 4,
    name: "Cascade Tassel Earrings",
    category: "Jewelry",
    price: "875.00",
    reviews: "178",
    rating: "4.6",
    image: "/img/shiskerstone/product-04.svg#view-1",
    images: ["/img/shiskerstone/product-04.svg#view-1", "/img/shiskerstone/product-04.svg#view-2"],
    size: ["One size"],
    colors: ["Gold", "Black"],
    material: "18k Gold Vermeil",
    description: [
      "The Cascade Tassel Earrings bring fluid movement to a clean silhouette with hand-knotted silk suspended from sculpted caps.",
      "Each earring features hand-knotted silk tassels suspended from a sculpted gold vermeil cap, creating a luxurious weight and movement.",
      "The tassels are crafted using traditional techniques passed down through generations of French couture houses, ensuring exceptional quality.",
      "These earrings transition seamlessly from afternoon elegance to evening sophistication, adding a touch of drama to any ensemble.",
      "The lever-back closure ensures secure fit while maintaining the aesthetic integrity of the design.",
    ],
    Features: [
      "18k gold vermeil construction",
      "Hand-knotted silk tassels",
      "Approximate tassel length: 8cm",
      "Lever-back closure for secure fit",
      "Lightweight design for all-day comfort",
      "Ships in shiskerstone presentation packaging",
      "Avoid contact with water and perfumes",
    ],
  },
  {
    id: 5,
    name: "Ember Crescent Ring",
    category: "Jewelry",
    price: "2500.00",
    reviews: "305",
    rating: "4.8",
    image: "/img/shiskerstone/product-05.svg#view-1",
    images: ["/img/shiskerstone/product-05.svg#view-1", "/img/shiskerstone/product-05.svg#view-2", "/img/shiskerstone/product-05.svg#view-3"],
    size: ["5", "6", "7", "8"],
    colors: ["Carnelian", "Gold"],
    material: "18k Gold with Carnelian",
    description: [
      "The Ember Crescent Ring frames a hand-cut carnelian cabochon in a warm, open setting that lets its natural color glow.",
      "Carnelian has been revered since antiquity for its warm, fiery energy and protective qualities, making this ring both beautiful and meaningful.",
      "The crescent moon setting cradles the organic, polished stone while allowing light to pass through, illuminating its natural warmth.",
      "Each stone is unique, with variations in color and pattern that make every ring one-of-a-kind.",
      "This substantial ring makes a powerful statement as a cocktail piece or can be stacked with finer bands for a layered look.",
    ],
    Features: [
      "Solid 18k gold band with high-polish finish",
      "Hand-cut natural carnelian stone",
      "Crescent moon prongs holding the stone",
      "Available in sizes 5-8",
      "Band width: 3mm",
      "Stone dimensions: approximately 12mm x 8mm",
      "Comes with jewelry pouch and care instructions",
    ],
  },
  {
    id: 6,
    name: "Solenne Carnelian Drops",
    category: "Jewelry",
    price: "695.00",
    reviews: "198",
    rating: "4.4",
    image: "/img/shiskerstone/product-06.svg#view-1",
    images: ["/img/shiskerstone/product-06.svg#view-1", "/img/shiskerstone/product-06.svg#view-2"],
    size: ["One size"],
    colors: ["Carnelian", "Gold"],
    material: "18k Gold with Carnelian",
    description: [
      "The Solenne Carnelian Drops suspend faceted natural stones from delicate gold hooks for an easy, elongated silhouette.",
      "Each pair showcases carefully selected carnelian gems known for their warm orange-red hues and subtle translucency when held to light.",
      "The faceted cuts maximize the stone's natural brilliance while the simple hook-back design ensures effortless wearability.",
      "These earrings add a sophisticated pop of color to both casual and formal ensembles, complementing warm tones in the complexion.",
      "The lightweight construction makes them comfortable for extended wear, ideal for special occasions or everyday elegance.",
    ],
    Features: [
      "18k gold hook back findings",
      "Natural faceted carnelian stones",
      "Drop length: approximately 4.5cm",
      "Stone dimensions: approximately 10mm diameter",
      "Lightweight for comfortable all-day wear",
      "Sold as a pair",
      "Avoid exposure to water and harsh chemicals",
    ],
  },
  {
    id: 7,
    name: "Meridian Pearl Necklace, 52in",
    category: "Jewelry",
    price: "1800.00",
    reviews: "240",
    rating: "4.7",
    image: "/img/shiskerstone/product-07.svg#view-1",
    images: ["/img/shiskerstone/product-07.svg#view-1", "/img/shiskerstone/product-07.svg#view-2"],
    size: ["52 inches"],
    colors: ["Gold", "Pearl"],
    material: "18k Gold with Freshwater Pearls",
    description: [
      "The 52-inch Meridian Pearl Necklace can be wrapped in several ways, shifting easily from a long strand to a layered arrangement.",
      "Hand-strung freshwater pearls of varied sizes are punctuated by smooth, abstract 18k gold beads designed for shiskerstone.",
      "The generous length allows for creative styling—worn long for drama, wrapped twice for sophistication, or tripled as a statement piece.",
      "Each pearl is individually knotted on silk thread, ensuring durability while allowing the necklace to drape beautifully.",
      "Its generous length and balanced weight make it adaptable for relaxed or formal styling.",
    ],
    Features: [
      "18k gold sculptural beads with high-polish finish",
      "Hand-strung freshwater pearls, AAA quality",
      "Total length: 52 inches (132cm)",
      "Individual pearl knotting on silk thread",
      "Gold lobster clasp with extender chain",
      "Pearl sizes range from 6mm to 10mm",
      "Can be styled multiple ways",
    ],
  },
  {
    id: 8,
    name: "Grand Baroque Pearl Drops",
    category: "Jewelry",
    price: "625.00",
    reviews: "190",
    rating: "4.8",
    image: "/img/shiskerstone/product-08.svg#view-1",
    images: ["/img/shiskerstone/product-08.svg#view-1", "/img/shiskerstone/product-08.svg#view-2", "/img/shiskerstone/product-08.svg#view-3"],
    size: ["One size"],
    colors: ["Pearl", "Gold"],
    material: "18k Gold with Baroque Pearls",
    description: [
      "The Grand Baroque Pearl Drops pair softly asymmetric gold caps with naturally irregular freshwater pearls.",
      "Each smooth gold cap follows the shape of its pearl, creating an original transition between polished and organic surfaces.",
      "Baroque pearls are prized for their unique, irregular shapes that catch light differently from every angle, ensuring no two pairs are identical.",
      "The substantial scale of these earrings commands attention while remaining surprisingly lightweight for comfortable extended wear.",
      "Designed for a strong entrance, the pair balances polished geometry with the natural character of each pearl.",
    ],
    Features: [
      "18k gold sculptural cap with original linear engraving",
      "Lustrous baroque freshwater pearls",
      "Drop length: approximately 7cm",
      "Pearl size: approximately 14-16mm",
      "Lever-back closure for security",
      "Lightweight hollow gold construction",
      "Each pair is unique due to natural pearl variations",
    ],
  },
  {
    id: 9,
    name: "Winged Keepsake Coffret",
    category: "Objects",
    price: "1375.00",
    reviews: "256",
    rating: "4.7",
    image: "/img/shiskerstone/product-09.svg#view-1",
    images: ["/img/shiskerstone/product-09.svg#view-1", "/img/shiskerstone/product-09.svg#view-2", "/img/shiskerstone/product-09.svg#view-3"],
    size: ["One size"],
    colors: ["Gold", "Turquoise"],
    material: "18k Gold with Semi-precious Stones",
    description: [
      "The Winged Keepsake Coffret is an original sculptural box shaped around the lines of a folded seed pod.",
      "Crafted in polished 18k gold with abstract engraved panels, its hinged body opens to reveal a velvet-lined interior.",
      "The coffret holds rings, small keepsakes, or other meaningful objects in a compact protective interior.",
      "Semi-precious stone accents in turquoise or lapis complement the gold, adding depth and color to the symbolic design.",
      "This collectible piece works beautifully as a decorative object on a vanity or bedside table when not in use.",
    ],
    Features: [
      "Solid 18k gold construction with hinged opening",
      "Velvet-lined interior compartment",
      "Turquoise or lapis lazuli stone accents",
      "Original abstract wing-line engraving",
      "Approximate dimensions: 6cm x 4cm x 2cm",
      "Push-button clasp for secure closure",
      "Presentation box included",
    ],
  },
  {
    id: 10,
    name: "Meridian Pearl Necklace, 30in",
    category: "Jewelry",
    price: "1150.00",
    reviews: "312",
    rating: "4.9",
    image: "/img/shiskerstone/product-10.svg#view-1",
    images: ["/img/shiskerstone/product-10.svg#view-1", "/img/shiskerstone/product-10.svg#view-2", "/img/shiskerstone/product-10.svg#view-3"],
    size: ["30 inches"],
    colors: ["Gold", "Pearl"],
    material: "18k Gold with Freshwater Pearls",
    description: [
      "The 30-inch Meridian Pearl Necklace balances hand-strung pearls with smooth gold beads at an easy mid-length.",
      "This versatile length works beautifully alone as a statement piece or can be layered with longer chains for a personalized look.",
      "The alternating pearl and abstract gold bead pattern creates a calm, evenly spaced visual rhythm.",
      "Each pearl is individually knotted on silk thread, ensuring the necklace maintains its beautiful drape while protecting the gems.",
      "The refined scale makes this piece appropriate for both everyday elegance and special occasions.",
    ],
    Features: [
      "Original smooth 18k gold sculptural beads",
      "Hand-strung freshwater pearls, AA quality",
      "Total length: 30 inches (76cm)",
      "Individual pearl knotting on silk thread",
      "Gold lobster clasp with extender",
      "Pearl sizes: approximately 8mm",
      "Perfect for layering or wearing alone",
    ],
  },
  {
    id: 11,
    name: "Onyx Halo Cuff",
    category: "Jewelry",
    price: "350.00",
    reviews: "198",
    rating: "4.6",
    image: "/img/shiskerstone/product-11.svg#view-1",
    images: ["/img/shiskerstone/product-11.svg#view-1", "/img/shiskerstone/product-11.svg#view-2", "/img/shiskerstone/product-11.svg#view-3"],
    size: ["Small", "Medium", "Large"],
    colors: ["Onyx", "Gold"],
    material: "18k Gold Vermeil with Onyx",
    description: [
      "The Onyx Halo Cuff is a bold open bangle centered by a polished black onyx disc in a clean offset frame.",
      "The circular geometry and dark gemstone create a high-contrast, contemporary statement.",
      "Hand-crafted in 18k gold vermeil over sterling silver, the cuff features a flexible opening that allows for easy wear and a custom fit.",
      "The high-contrast combination of black onyx and warm gold creates a dramatic statement piece suitable for both day and evening wear.",
      "The substantial weight of the cuff provides a satisfying presence on the wrist while the polished finish catches light beautifully.",
    ],
    Features: [
      "18k gold vermeil over sterling silver",
      "Polished natural black onyx disc",
      "Cuff circumference: approximately 6 inches",
      "Flexible opening for adjustable fit",
      "Disc diameter: approximately 25mm",
      "High-polish finish on gold elements",
      "Ships in shiskerstone presentation packaging",
    ],
  },
  {
    id: 12,
    name: "Winged Enamel Collar",
    category: "Jewelry",
    price: "2800.00",
    reviews: "267",
    rating: "4.5",
    image: "/img/shiskerstone/product-12.svg#view-1",
    images: ["/img/shiskerstone/product-12.svg#view-1", "/img/shiskerstone/product-12.svg#view-2", "/img/shiskerstone/product-12.svg#view-3"],
    size: ["One size"],
    colors: ["Gold", "Enamel"],
    material: "18k Gold with Enamel",
    description: [
      "The Winged Enamel Collar is a dramatic articulated necklace built from graduated abstract links.",
      "Cast in 18k gold, each original wing-shaped link is joined to follow the neckline with comfortable movement.",
      "Deep blue or emerald enamel accents add measured color and emphasize the rhythm of the links.",
      "The collar fastens at the back with an elegant gold lobster clasp, while the front features an adjustable chain for a customizable fit.",
      "The articulated construction brings contemporary movement to a substantial jewelry silhouette.",
    ],
    Features: [
      "Solid 18k gold construction",
      "Hand-applied enamel accents",
      "Graduated abstract wing-link design",
      "Adjustable length: approximately 14-16 inches",
      "Lobster clasp closure with extender chain",
      "Total pendant drop: approximately 5cm",
      "Clips or pins included for securing to clothing",
    ],
  },
  {
    id: 13,
    name: "Turquoise Wing Brooch",
    category: "Jewelry",
    price: "1500.00",
    reviews: "223",
    rating: "4.6",
    image: "/img/shiskerstone/product-13.svg#view-1",
    images: ["/img/shiskerstone/product-13.svg#view-1", "/img/shiskerstone/product-13.svg#view-2", "/img/shiskerstone/product-13.svg#view-3"],
    size: ["One size"],
    colors: ["Gold", "Turquoise"],
    material: "18k Gold with Turquoise",
    description: [
      "The Turquoise Wing Brooch combines fine linear engraving with small natural stone accents in an original abstract form.",
      "Hand-cast in 18k gold using the lost-wax method, the brooch preserves the delicate ridges and softly irregular edge of the model.",
      "Small turquoise cabochons add focused color against the warm polished surface.",
      "This versatile brooch works beautifully on jackets, coats, scarves, or as a decorative element on bags and hats.",
      "The secure pin mechanism ensures it stays in place while the substantial weight gives it a premium feel.",
    ],
    Features: [
      "Solid 18k gold casting with high-polish finish",
      "Natural turquoise cabochon accent",
      "Detailed wing engraving with texture variation",
      "Spring pin closure for secure attachment",
      "Approximate dimensions: 5cm x 4cm",
      "Substantial weight for quality feel",
      "Presentation box included",
    ],
  },
  {
    id: 14,
    name: "Winged Keepsake Pill Box",
    category: "Objects",
    price: "1200.00",
    reviews: "198",
    rating: "4.7",
    image: "/img/shiskerstone/product-14.svg#view-1",
    images: ["/img/shiskerstone/product-14.svg#view-1", "/img/shiskerstone/product-14.svg#view-2", "/img/shiskerstone/product-14.svg#view-3"],
    size: ["One size"],
    colors: ["Gold", "Cognac"],
    material: "18k Gold with Leather",
    description: [
      "The Winged Keepsake Pill Box is a compact decorative object for storing small personal items.",
      "A domed gold lid with original feather-line engraving meets a leather-wrapped lower body, balancing sculpture and function.",
      "The interior is velvet-lined to protect contents, while the hinged lid opens with a satisfying click via a discreet push-button mechanism.",
      "The pill box makes a distinctive addition to a vanity or bedside table, or can be carried as a talking point at dinner parties.",
      "Each piece combines traditional hand-finishing techniques with a clean contemporary design.",
    ],
    Features: [
      "18k gold domed lid with original feather-line texture",
      "Leather-wrapped body in cognac or black",
      "Velvet-lined interior",
      "Hinged lid with push-button closure",
      "Approximate dimensions: 7cm x 4cm",
      "Weight: approximately 80 grams",
      "Custom presentation box included",
    ],
  },
  {
    id: 15,
    name: "Medium Baroque Pearl Drops",
    category: "Jewelry",
    price: "550.00",
    reviews: "312",
    rating: "4.8",
    image: "/img/shiskerstone/product-15.svg#view-1",
    images: ["/img/shiskerstone/product-15.svg#view-1", "/img/shiskerstone/product-15.svg#view-2"],
    size: ["One size"],
    colors: ["Pearl", "Gold"],
    material: "18k Gold with Freshwater Pearls",
    description: [
      "The Medium Baroque Pearl Drops balance everyday scale with softly folded gold caps and luminous freshwater pearls.",
      "These versatile earrings work effortlessly from day to evening, adding understated elegance to any outfit without overwhelming the look.",
      "Subtle lines on the original gold caps catch the light while the pearl drops add organic warmth below.",
      "Baroque pearls are chosen for their distinctive character—each pair unique in shape and iridescence.",
      "The medium scale makes these earrings comfortable for extended wear while still making a noticeable impact.",
    ],
    Features: [
      "18k gold sculptural cap with fine engraving",
      "Lustrous baroque freshwater pearl drops",
      "Drop length: approximately 5cm",
      "Pearl size: approximately 10-12mm",
      "Lever-back closure",
      "Lightweight construction",
      "Unique due to natural pearl variations",
    ],
  },
  {
    id: 16,
    name: "Meridian Pearl Necklace, 24in",
    category: "Jewelry",
    price: "925.00",
    reviews: "187",
    rating: "4.7",
    image: "/img/shiskerstone/product-16.svg#view-1",
    images: ["/img/shiskerstone/product-16.svg#view-1", "/img/shiskerstone/product-16.svg#view-2"],
    size: ["24 inches"],
    colors: ["Gold", "Pearl"],
    material: "18k Gold with Freshwater Pearls",
    description: [
      "The 24-inch Meridian Pearl Necklace sits at the base of the throat to showcase its smooth gold beads and luminous pearl strand.",
      "This shorter length creates a focal point at the décolletage, ideal for showing off the necklace above a crew neck or worn alone.",
      "Hand-strung freshwater pearls alternate with original abstract gold beads, each individually knotted on silk thread.",
      "The necklace layers easily with other shiskerstone pieces or stands on its own.",
      "A lobster clasp with extender chain provides flexibility in fit and allows the necklace to be customized to any neckline.",
    ],
    Features: [
      "Original 18k gold sculptural beads",
      "Hand-strung freshwater pearls, AA quality",
      "Total length: 24 inches (61cm)",
      "Individual pearl knotting on silk thread",
      "Gold lobster clasp with 2-inch extender",
      "Pearl sizes: approximately 7-8mm",
      "Ideal for layering or solo styling",
    ],
  },
  {
    id: 17,
    name: "Everyday Onyx Choker",
    category: "Jewelry",
    price: "795.00",
    reviews: "234",
    rating: "4.6",
    image: "/img/shiskerstone/product-17.svg#view-1",
    images: ["/img/shiskerstone/product-17.svg#view-1", "/img/shiskerstone/product-17.svg#view-2", "/img/shiskerstone/product-17.svg#view-3"],
    size: ["One size"],
    colors: ["Onyx", "Gold"],
    material: "18k Gold with Black Onyx",
    description: [
      "The Everyday Onyx Choker pairs polished black beads with small original gold spacers in a compact, versatile length.",
      "Polished black onyx beads alternate with softly fluted gold accents for a restrained rhythm.",
      "The graduated bead size creates a flattering frame for the face while the adjustable silk thread allows for a customized fit.",
      "The dark elegance of onyx combined with warm gold makes this choker incredibly versatile, transitioning effortlessly from day to evening.",
      "Despite its precious materials, the choker is balanced for comfortable regular wear.",
    ],
    Features: [
      "Original softly fluted 18k gold accents",
      "Polished black onyx beads",
      "Adjustable silk thread closure",
      "Total length: approximately 14-16 inches",
      "Bead sizes: 4mm to 8mm graduated",
      "Lightweight for all-day comfort",
      "Ships in a shiskerstone jewelry pouch",
    ],
  },
  {
    id: 18,
    name: "Petite Onyx Drop Earrings",
    category: "Jewelry",
    price: "550.00",
    reviews: "201",
    rating: "4.6",
    image: "/img/shiskerstone/product-18.svg#view-1",
    images: ["/img/shiskerstone/product-18.svg#view-1", "/img/shiskerstone/product-18.svg#view-2"],
    size: ["One size"],
    colors: ["Onyx", "Gold"],
    material: "18k Gold with Black Onyx",
    description: [
      "The Petite Onyx Drop Earrings offer a refined everyday scale with polished stones and simple gold findings.",
      "These delicate drop earrings feature small faceted onyx stones suspended from minimalist gold hooks, adding subtle drama without overwhelming.",
      "The faceted cuts of the onyx create depth and light reflection, making even this small stone a noticeable presence.",
      "Designed for stacking and layering, these earrings work beautifully alongside other piercings or alone for understated elegance.",
      "The tiny scale makes them incredibly comfortable for daily wear while the precious materials ensure they remain special.",
    ],
    Features: [
      "18k gold hook back findings",
      "Faceted natural black onyx stones",
      "Drop length: approximately 2.5cm",
      "Stone dimensions: approximately 6mm",
      "Ultra-lightweight construction",
      "Sold as a pair",
      "Perfect for multiple ear piercings",
    ],
  },
  {
    id: 19,
    name: "Rock Crystal Orb",
    category: "Objects",
    price: "3975.00",
    reviews: "276",
    rating: "4.8",
    image: "/img/shiskerstone/product-19.svg#view-1",
    images: ["/img/shiskerstone/product-19.svg#view-1", "/img/shiskerstone/product-19.svg#view-2"],
    size: ["One size"],
    colors: ["Crystal", "Gold"],
    material: "18k Gold with Crystal",
    description: [
      "The Crystal Ball is a sculptural object of contemplation, featuring a hand-blown crystal sphere resting in an intricate gold holder.",
      "Each crystal sphere is unique, formed through a process that creates natural inclusions and variations within the clear quartz.",
      "The gold holder is cast using the lost-wax technique and finished with original asymmetric ridges that support the sphere securely.",
      "The object can be displayed on a desk, vanity, shelf, or other quiet space in the home.",
      "The Crystal Ball makes an exceptional gift for those who appreciate functional art and meaningful objects.",
    ],
    Features: [
      "Hand-blown clear quartz crystal sphere",
      "18k gold sculptural base with detailed engraving",
      "Crystal diameter: approximately 8cm",
      "Total height: approximately 12cm",
      "Weighted base for stability",
      "Natural variations in crystal make each unique",
      "Custom presentation box included",
    ],
  },
  {
    id: 20,
    name: "Enamel Dragonfly Holder",
    category: "Objects",
    price: "3700.00",
    reviews: "189",
    rating: "4.6",
    image: "/img/shiskerstone/product-20.svg#view-1",
    images: ["/img/shiskerstone/product-20.svg#view-1", "/img/shiskerstone/product-20.svg#view-2"],
    size: ["One size"],
    colors: ["Gold", "Enamel"],
    material: "18k Gold with Enamel",
    description: [
      "The Dragonfly Cigarette Holder is a masterpiece of sculptural craft, transforming a functional object into a wearable work of art.",
      "The dragonfly motif is rendered with extraordinary detail—wings detailed with fine engraving, body segments articulated for realism.",
      "Hand-crafted in 18k gold with optional enamel accents in deep blue or emerald green, referencing the iridescent colors of dragonflies.",
      "The elongated form adds drama to the gesture of holding a cigarette, while the weighted construction ensures comfortable handling.",
      "This exceptional piece transcends its function, serving as both a practical accessory and a collectible sculpture.",
    ],
    Features: [
      "Solid 18k gold construction with lost-wax casting",
      "Hand-applied enamel wings in blue or green",
      "Intricate wing vein detailing",
      "Weighted brass core for comfortable handling",
      "Total length: approximately 15cm",
      "Suitable for standard cigarettes",
      "Custom presentation box included",
    ],
  },
];

export default productData;
